import { ComponentMenuBar, ProgressBar } from "@components";
import { PATH_PROFILE, PATH_USER_SETTING, enumNavigation, enumTheme } from "@configs";
import { IInfo, IMemberShipTiers } from "@interfaces";
import { selectMerchant } from "@redux";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled, { CSSProperties } from "styled-components";
import { IconEditProfile } from "./icon/IconEditProfile";
import { RightArrow } from "./icon/RightArror";

interface IProps {
    themeColor: string;
    userInfo: IInfo | null;
    memberShipTiers: IMemberShipTiers[];
    under: enumNavigation;
    handleToggleUnder: (value: enumNavigation) => void;
    handleToggleQrCode: () => void;
    handleSwitchUserSetting: () => void;
    handleSwitchTier: () => void;
}

const styleAvatarUser: CSSProperties = {
    marginTop: "-52px",
    width: "64px",
    height: "64px",
};
const styleCircleImg: CSSProperties = {
    width: "64px",
    height: "64px",
};
export const ComponentProfilePrivilege = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || enumTheme.LIGHT;
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    //page variable
    const {
        themeColor,
        userInfo,
        memberShipTiers,
        under,
        handleToggleUnder,
        handleToggleQrCode,
        handleSwitchUserSetting,
        handleSwitchTier,
        // handleCoupon,
    } = props;

    // current membership used bath
    const currentPoint = userInfo?.totalPoints || 0;
    const currentTierPointThreshold = userInfo?.memberTier?.pointThreshold || 0;

    // next membership
    const nextTiers = memberShipTiers?.filter(
        (item) =>
            item.pointThreshold > currentPoint &&
            item._id !== userInfo?.memberTier?._id &&
            item.pointThreshold > currentTierPointThreshold
    );

    const handleEdit = () => {
        history.push(PATH_USER_SETTING);
    };

    return (
        <>
            {/* <div className="background"></div> */}
            <div className="preview">
                <StyledPageProfile
                    themeColor={themes?.themeColor!}
                    colorTier={userInfo?.memberTier?.textOverlayColor}
                >
                    <div className="layouts-profile">
                        <div className="layout-header-profile">
                            <div className="img-profile">
                                {/* <img src="../images/img-profile.png" alt="imgprofile" /> */}
                                <img
                                    src={userInfo?.avatar || "../images/img-profile-default-01.png"}
                                    alt="imgprofile"
                                />
                            </div>
                            <div className="fullname">
                                {merchant?.advanceSettings?.tier?.isFullName
                                    ? userInfo?.contact?.fullName
                                    : userInfo?.contact?.firstName +
                                    " " +
                                    userInfo?.contact?.lastName}{" "}
                                <span onClick={handleEdit}>
                                    <IconEditProfile />
                                </span>
                            </div>
                            <div className="point">
                                {merchant?.securityConfig?.isPointDisplay === true && (
                                    <>
                                        {userInfo?.totalPoints ? (
                                            <StyledPointTier
                                                color={userInfo?.memberTier?.textOverlayColor}
                                            >
                                                {userInfo?.totalPoints?.toLocaleString()} {t("page.point")}
                                            </StyledPointTier>
                                        ) : null}
                                    </>
                                )}

                                {merchant?.advanceSettings?.advanceFeature?.isMemberShipTier ? (
                                    <StyledColorTier color={userInfo?.memberTier?.textOverlayColor}>
                                        {userInfo?.memberTier?.tierName}
                                    </StyledColorTier>
                                ) : null}

                                {/* Valid before : {formatDateMath(userInfo?.contact?.memberCurrentTierDate)} */}
                                {/* <span>{userInfo?.memberTier?.tierName}</span> */}
                            </div>
                            <div className="edit" onClick={() => history.push(PATH_PROFILE)}>
                                <RightArrow />
                            </div>
                        </div>
                    </div>
                    <ComponentMenuBar />
                </StyledPageProfile>
            </div>
        </>
    );
};

const StyledColorTier = styled.span`
    color: ${(props) => props.color || "#000"};
    font-weight: 600;
`;
const StyledPointTier = styled.span`
    color: ${(props) => props.color || "#000"};
    font-weight: 600;
`;

const StyledPageProfile = styled.div<{ themeColor: string; colorTier: string | undefined }>`
    .layouts-profile {
        .layout-header-profile {
            position: relative;
            padding: 10px 30px 10px 70px;
            margin-bottom: 10px;
            .img-profile {
                width: 50px;
                height: 50px;
                border-radius: 100%;
                overflow: hidden;
                border: 2px solid ${(p) => p.themeColor};
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 100%;
                    border: 1px solid #fff;
                }
            }
            .fullname {
                font-size: 18px;
                line-height: 22px;
                color: ${(props) => props.colorTier || "#000"};
                font-weight: 500;
                margin-bottom: 5px;
                span {
                    margin-left: 5px;
                    margin-top: -2px;
                    filter: grayscale(1);
                }
            }
            .point {
                font-size: 12px;
                line-height: 16px;
                span {
                    &:nth-child(2) {
                        position: relative;
                        padding-left: 5px;
                        margin-left: 5px;
                        &:after {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 1px;
                            height: 10px;
                            background-color: #000;
                        }
                    }
                }
            }
            .edit {
                position: absolute;
                right: 0;
                top: 50%;
                cursor: pointer;
                transform: translateY(-50%);
            }
        }

        .layout-card-profile {
            position: relative;
            min-height: 110px;
            margin-bottom: 10px;
            border-radius: 16px;
            max-height: 110px;
            overflow: hidden;

            img {
                width: 100%;
            }
            .detail-card-profile {
                position: absolute;
                left: 20px;
                top: 10px;
                .point-card-profile {
                    font-size: 20px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    span {
                        margin-left: 5px;
                        img {
                            width: 16px;
                        }
                    }
                }
                .text-card-profile {
                    font-size: 11px;
                    color: #fff;
                }
            }
            .reward-card-profile {
                position: absolute;
                top: 17px;
                right: 17px;
                padding: 6px 10px;
                font-size: 10px;
                color: #fff;
                border-radius: 50px;
                background-color: #c4a363;
            }
        }
    }
`;
const StyledProgressBar = styled(ProgressBar)`
    cursor: pointer;
`;
const StyledProgressText = styled.div<{ themeColor: string }>`
    .next-spendBath {
        color: ${(p) => p.themeColor};
    }
`;
